var render = function render(){var _vm=this,_c=_vm._self._c;return _c('micro-app',{attrs:{"name":"AppPkg31","url":_vm.url,"keep-alive":"","default-page":_vm.defaultPage},on:{"created":_vm.created,"beforemount":_vm.beforemount,"mounted":_vm.mounted,"afterhidden":_vm.afterhidden,"beforeshow":_vm.beforeshow,"aftershow":_vm.aftershow,"error":_vm.error}})
}
var staticRenderFns = []

export { render, staticRenderFns }